import AttendanceSheetStatusIcon from '@/modules/business/attendance-sheet/presentation/components/IconeStatus';
import Links from '@/shared/constants/navegacao';
import { AttendanceSheetPdf } from '@/modules/business/attendance-sheet/presentation/components/AttendanceSheetPDF';
import { Button } from 'react-bootstrap';
import { FaEye, FaRegFilePdf, FaTrash } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { ListAllIntershipsOfTheMonthResponseDto } from '@/api.types';
import {
  deleteAttendanceSheet,
  readByIdAttendanceSheet,
} from '@/modules/business/attendance-sheet/attendance-sheet.service';
import { exportFromJsxToPdf } from '@/shared/utils/pdf';
import { toast } from 'react-toastify';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

type FolhasPerfilTableProps = {
  folhas: ListAllIntershipsOfTheMonthResponseDto[];
  emptyMessage: string;
  carregando: boolean;
  permissaoExcluirFolhas: boolean;
  onExcluida: () => void;
};

function formatarReferenciaFolha(ano: number, mes: number): string {
  const texto = format(new Date(ano, mes - 1, 1), 'MMMM / yyyy', { locale: ptBR });
  return texto.charAt(0).toUpperCase() + texto.slice(1);
}

export function FolhasPerfilTable({
  folhas,
  emptyMessage,
  carregando,
  permissaoExcluirFolhas,
  onExcluida,
}: FolhasPerfilTableProps) {
  const handlePrintAttendanceSheet = async (folhaId: string) => {
    try {
      const folha = await readByIdAttendanceSheet(folhaId);
      exportFromJsxToPdf(<AttendanceSheetPdf folha={folha} />);
    } catch (error) {
      toast.error(String(error));
    }
  };

  const handleDeleteAttendanceSheet = async (folhaId: string) => {
    const confirmed = window.confirm('Deseja realmente excluir esta folha de frequência?');
    if (!confirmed) return;

    try {
      const deleted = await deleteAttendanceSheet(folhaId);
      if (deleted) {
        toast.success('Folha de frequência excluída com sucesso.');
        onExcluida();
        return;
      }
      toast.error('Não foi possível excluir a folha de frequência.');
    } catch (error) {
      toast.error(String(error));
    }
  };

  if (carregando) {
    return <p className="text-muted small mb-0 py-1">Carregando folhas...</p>;
  }

  if (folhas.length === 0) {
    return <p className="text-muted small mb-0 py-1">{emptyMessage}</p>;
  }

  return (
    <table className="table table-sm table-bordered table-hover table-striped text-center mb-0">
      <thead>
        <tr>
          <th>Referência</th>
          <th>Status</th>
          <th>Unidade</th>
          <th>Responsável</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        {folhas.map((row) => (
          <tr key={row.folha?.id ?? `${row.ano}-${row.mes}`}>
            <td>{formatarReferenciaFolha(row.ano, row.mes)}</td>
            <td>
              {row.folha?.id ? (
                <Link to={`${Links.Folha_Frequencia_Editar}/${row.folha.id}`}>
                  <AttendanceSheetStatusIcon status={row.folha.status} />
                </Link>
              ) : (
                '-'
              )}
            </td>
            <td>{row.estagio?.unidade || '-'}</td>
            <td>{row.responsavel?.nome || '-'}</td>
            <td>
              {row.folha?.id ? (
                <div className="d-flex align-items-center justify-content-center gap-2">
                  <Link
                    className="link-secondary"
                    to={`${Links.Folha_Frequencia_Editar}/${row.folha.id}`}
                    title="Visualizar a folha."
                  >
                    <FaEye size={22} color="#0daaaf" />
                  </Link>
                  <Button
                    className="btn btn-link link-secondary p-0"
                    onClick={() => handlePrintAttendanceSheet(row.folha!.id)}
                    title="Gerar PDF da folha."
                  >
                    <FaRegFilePdf size={20} color="#ff4444" />
                  </Button>
                  {permissaoExcluirFolhas ? (
                    <Button
                      className="btn btn-link link-secondary p-0"
                      onClick={() => handleDeleteAttendanceSheet(row.folha!.id)}
                      title="Excluir folha (somente sem dias preenchidos)."
                    >
                      <FaTrash size={18} color="#dc3545" />
                    </Button>
                  ) : null}
                </div>
              ) : null}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
